import clsx from 'clsx';

import { DATATABLE_CELL_CLASS } from '../DataTableConstants';
import ColumnCell from './ColumnCell';

export default function BodyCell(props) {
    const { column, children, tooltip } = props;

    return (
        <ColumnCell
            variant="body"
            column={column}
            className={clsx(column.className, DATATABLE_CELL_CLASS)}
            tooltip={tooltip}
        >
            {children}
        </ColumnCell>
    );
}
